import script from "./SettlementSummaryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettlementSummaryCard.vue?vue&type=script&setup=true&lang=ts"

import "./SettlementSummaryCard.vue?vue&type=style&index=0&id=2764d5e4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2764d5e4"]])

export default __exports__